module.exports = __webpack_public_path__ + "static/d-30ffe58ad67d3d9288471a2198c35d63.jpg";